import { useEffect, useState } from 'react';
import { Box, Stack, LinearProgress, Typography } from '@mui/material'
import Image from "./Image";
import { LOGO_PATH } from '../config'

type Props = {
    text?: boolean;
}

export default function UrbiaLoading({text} : Props){
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        const timer = setInterval(() => {
          setProgress((oldProgress) => {
            if (oldProgress >= 95) {
              return 95;
            }
            const diff = Math.random() * 3;
            return Math.min(oldProgress + diff, 100);
          });
        }, 500);

        return () => {
          clearInterval(timer);
        };
      }, []);

    return(

        <Box id="teeee" component="div" sx={{alignItems: 'center', display: 'flex', justifyContent: 'center', width:'100%', height: 'calc(100% - 64px)', zIndex:'9999999999999', position:'absolute', background: 'white'}}>
            <Stack spacing={4} alignItems='center'>
                <Image sx={{maxWidth: '180px', maxHeight: '64px'}} disabledEffect src={process.env.PUBLIC_URL + LOGO_PATH} alt='LOGO'/>
                <Stack spacing={2} alignItems='center'>
                    <LinearProgress variant="determinate" value={progress} sx={{height:'5px', width:'360px'}}/>
                    {text &&
                        <Typography variant='h6' color='InactiveCaptionText'>
                            Carregando dados...
                        </Typography>
                    }
                </Stack>
            </Stack>
        </Box>

    )
}
